export default __webpack_public_path__ + "static/media/PoseAnalysis.fa0bbc66.jpg";